import { Component, Injector, OnInit } from '@angular/core';
import { ClientService } from 'tnx-admin-service/client-management/services';
import { ColumnSchemaBase, ComponentContextService, DataListBase, GridInfo, ModelSchema, Sort } from 'tnx-shared';

@Component({
    selector: 'client-management',
    templateUrl: './client-management.component.html',
    styleUrls: ['./client-management.component.scss'],
    providers: [ComponentContextService],
})
export class ClientManagementComponent extends DataListBase implements OnInit {
    dataProcedures: any[] = [];
    arrType = [];

    searchModel;

    constructor(
        protected _clientService: ClientService,
        protected _injector: Injector,
    ) {
        super(_injector);
    }

    ngOnInit() {
        this.setting.objectName = 'ứng dụng được xác thực';
        this.setting.baseService = this._clientService;
        this.setting.modelSchemas = <ModelSchema[]>[
            new ModelSchema({
                field: 'clientId',
                name: 'Mã ứng dụng',
                fullName: 'Mã ứng dụng',
                description: '',
            }),
            new ModelSchema({
                field: 'clientName',
                name: 'Tên ứng dụng',
                fullName: 'Tên ứng dụng',
                description: '',
                dataType: 'string'
            }),
            new ModelSchema({
                field: 'description',
                name: 'Mô tả',
                fullName: '',
                description: '',
            }),
            new ModelSchema({
                field: 'allowedGrantType',
                name: 'Loại',
                fullName: 'Loại',
                description: ''
            }),
            new ModelSchema({
                field: 'email',
                fullName: 'Email',
                name: 'Email',
                description: '',
            }),
            new ModelSchema({
                field: 'endPoint',
                name: 'EndPoint',
                fullName: 'EndPoint',
                description: '',
            }),
            new ModelSchema({
                field: 'orgIdentity ',
                name: 'Mã đơn vị',
                fullName: 'Mã đơn vị',
                description: '',
            })
        ];
        this.setting.cols = <ColumnSchemaBase[]>[
            new ColumnSchemaBase({
                field: 'clientId',
                label: 'Mã ứng dụng',
                visible: true,
                width: '18%',
                sort: true
            }),
            new ColumnSchemaBase({
                field: 'clientName',
                label: 'Tên ứng dụng',
                visible: true,
                width: '14%',
                sort: true,
                dataType: 'string'
            }),
            new ColumnSchemaBase({
                field: 'description',
                label: 'Mô tả',
                visible: true,
                width: '14%',
                sort: true
            }),
            new ColumnSchemaBase({
                field: 'allowedGrantType',
                label: 'Loại',
                visible: true,
                width: '14%',
                sort: true,
                dataType: 'allowedGrantType'
            }),
            new ColumnSchemaBase({
                field: 'email',
                label: 'Email',
                dataType: 'email',
                visible: true,
                width: '14%',
                sort: false
            }),
            new ColumnSchemaBase({
                field: 'endPoint',
                label: 'EndPoint',
                dataType: 'endPoint',
                visible: true,
                width: '14%',
                sort: false
            }),
            new ColumnSchemaBase({
                field: 'orgIdentity ',
                label: 'Mã đơn vị',
                dataType: 'orgIdentity',
                visible: true,
                width: '14%',
                sort: false
            })
        ];
        super.ngOnInit();
    }

    async modifyGridInfo(gridInfo: GridInfo): Promise<boolean | void> {
        (<Sort[]>gridInfo.sorts).push(new Sort({
            field: 'created',
            dir: -1
        }))
    }
}
